module.exports = __webpack_public_path__ + "static/media/pressure-monitor-online.977cb944.svg";